<app-header extraClass="text-gray hideMobile" displayNavigation="true" displayProductSwitch="false"
            standardProduct="true"></app-header>

<section class="container mt-130 container-1080 mb-6 myprofile-wrp">
  <div class="myprofile-wrp-inner">
    <h4 class="heading-w-border hideMobile">
      <span>Your Profile</span>
    </h4>

    <div class="uk-flex myprofile-wrp-inner uk-flex-wrap">

      <!-- Profile Links -->
      <div class="w-30 myprofile-left-panel-wrp">
        <div class="myprofile-left-panel">

          <!-- 28 sep vip-->
          <div class="back-btn hidelg mb-3">
            <a [routerLink]="['/']">
              <img src="assets/images/icons/back-black-arrow-light.png" alt="">
            </a>
          </div>
          <!-- 28 sep vip-->

          <div class="position-relative center-block">
            <div class="profile-photo">
              <img src="assets/images/icons/profile-icon-big.png" id="upload-img" class="profileimg">
            </div>
            <div class="opencamera cursor-pointer">
              <div class="custom-file">
                <label for="fileupload"><img src="assets/images/icons/camera.png" alt=""></label>
                <input type="file" id="fileupload">
              </div>
            </div>
          </div>
          <!--position-relative-->

          <div class="myprofile-info text-center mt-15">
            <h4>{{userProfile.first_name}} {{userProfile.last_name}}</h4>
            <p>
              <!--<img src="assets/images/icons/location-black.png" alt="">-->
              <i class="fa fa-map-marker"></i>&nbsp; {{userProfile.city}} </p>
          </div>

          <ul class="uk-subnav mt-3" uk-switcher="animation: uk-animation-fade">
            <li><a class="profileclick" (click)="showMyProfile()">My Profile</a></li>
            <li class="uk-active"><a href="#" class="orderclick " (click)="showMyOrders()">My Orders</a></li>
            <li class=""><a class="bucketclick" (click)="showMyBucketlist()">My Bucketlist</a></li>
            <li><a [routerLink]="['/contact-us']" class="supportclick">Support</a></li>
            <li class=""><a (click)="showMyCoupons()" class="supportclick hidelg-link">My Coupons</a></li>
            <li class=""><a (click)="showMyPoll()" class="supportclick hidelg-link">My Poll History</a></li>
          </ul>

          <a class="btn-default mt-3 center-block" (click)="doLogout()">Logout</a>
        </div>
        <!--myprofile-left-panel-->
      </div>
      <!--w-30-->

      <div class="w-70 myprofile-tabs">

        <!--MYPROFILE-->
        <div class="myprofile-form pl-25" id="MyProfile">
          <form [formGroup]="profileForm" novalidate>
            <div class="myprofile-form-wrp">
              <div class="profile-heading uk-flex uk-flex-between mb-3">

                <!-- 28 sep vip -->
                <p class="uk-flex">
                  <a (click)="goBacktoMyAccount()" class="hidelg mr-15">
                    <img src="assets/images/icons/back-black-arrow-light.png" alt="">
                  </a>
                  Personal Details
                </p>
                <!-- 28 sep vip -->

                <div class="icon">
                  <img src="assets/images/icons/edit.png" alt="" class="editclick"
                       (click)="enableProfileEditing($event.target)">
                </div>
              </div>
              <div class="profile-form-field full-border-form uk-flex uk-flex-between uk-flex-wrap">

                <div class="form-group w-49" [formGroup]="profileForm">
                  <label for="">First Name.</label>
                  <div class="uk-inline">
                                        <span class="uk-form-icon">
                                       <!-- <img src="assets/images/icons/people.png" alt="">-->
                                       <i class="fa fa-user"></i>
                                    </span>
                    <input class="uk-input" value="{{userProfile.first_name}}" formControlName="first_name"
                           id="first_name" type="text">

                    <div
                      *ngIf="profileForm.controls['first_name'].invalid && profileForm.controls['first_name'].touched"
                      class="error">
                      <div *ngIf="profileForm.controls['first_name'].errors.required">
                        First Name is required.
                      </div>
                    </div>

                  </div>
                </div>
                <div class="form-group w-49" [formGroup]="profileForm">
                  <label for="">Last Name.</label>
                  <div class="uk-inline">
                                        <span class="uk-form-icon">
                                       <!-- <img src="assets/images/icons/people.png" alt="">-->
                                       <i class="fa fa-user"></i>
                                    </span>
                    <input class="uk-input" type="text" id="last_name" formControlName="last_name">

                    <div *ngIf="profileForm.controls['last_name'].invalid && profileForm.controls['last_name'].touched"
                         class="error">
                      <div *ngIf="profileForm.controls['last_name'].errors.required">
                        Last Name is required.
                      </div>
                    </div>
                  </div>
                </div>
                <!--form-group-->

                <div class="form-group w-49" [formGroup]="profileForm">
                  <label for="">City.</label>
                  <div class="select-people-drop">
                    <select class="uk-select" formControlName="city" id="city">
                      <option value="Mumbai">Mumbai</option>
                      <option value="Pune">Pune</option>
                    </select>
                  </div>

                  <div *ngIf="profileForm.controls['city'].invalid && profileForm.controls['city'].touched"
                       class="error">
                    <div *ngIf="profileForm.controls['city'].errors.required">
                      City is required.
                    </div>
                  </div>
                </div>
                <!--form-group-->

                <div class="form-group w-49" [formGroup]="profileForm">
                  <label for="">Mobile No.</label>
                  <div class="uk-inline">
                                        <span class="uk-form-icon">
                          <!--<img src="assets/images/icons/call.png" alt="">-->
                          <i class="fa fa-phone"></i>
                      </span>
                    <input class="uk-input" type="tel" formControlName="mobile_number" id="mobile_number">

                    <div
                      *ngIf="profileForm.controls['mobile_number'].invalid && profileForm.controls['mobile_number'].touched"
                      class="error">
                      <div *ngIf="profileForm.controls['mobile_number'].errors.required">
                        Mobile Number is required.
                      </div>
                      <div *ngIf="profileForm.controls['mobile_number'].errors.minlength">
                        Mobile number must be 10 digits
                      </div>
                      <div *ngIf="profileForm.controls['mobile_number'].errors.maxlength">
                        Max 10 digits allowed
                      </div>

                    </div>
                  </div>
                </div>
                <!--form-group-->

                <div class="form-group w-49" [formGroup]="profileForm">
                  <label for="">Email Id.</label>
                  <div class="uk-inline">
                                        <span class="uk-form-icon">
                                        <!--<img src="assets/images/icons/mail.png" alt="">-->
                                        <i class="fa fa-envelope"></i>
                                    </span>
                    <input class="uk-input" formControlName="email" id="email" type="email">
                    <div *ngIf="profileForm.controls['email'].invalid && profileForm.controls['email'].touched"
                         class="error">
                      <div *ngIf="profileForm.controls['email'].errors.required">
                        Email is required.
                      </div>
                      <div *ngIf="profileForm.controls['email'].errors.email">
                        Email is not valid.
                      </div>

                    </div>
                  </div>
                </div>
                <!--form-group-->

                <div class="form-group w-49" [formGroup]="profileForm">
                  <label for="">Birthday (Optional)</label>
                  <div class="uk-inlinex">
                                        <span class="uk-form-icon">
                       <!-- <img src="assets/images/icons/calendar-3.png" alt="">-->
                       <i class="fa fa-calendar"></i>

                    </span>
                    <input class="uk-input" type="date" formControlName="birthday" id="birthday">
                  </div>
                </div>

                <div class="form-group w-49" [formGroup]="profileForm">
                  <label for="">Married (Optional)</label>
                  <div class="select-people-drop">
                    <select class="uk-select" formControlName="marital_status" id="married">
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

                <!--form-group-->
                <div class="form-group w-100">
                  <button type="submit" class="btn-yellow" (click)="saveProfile()">Update</button>
                </div>

                <p *ngIf="errorMessage" class="error">
                  {{errorMessage}}
                </p>

                <p *ngIf="successMessage" class="uk-text-success">
                  {{successMessage}}
                </p>

              </div>
            </div>
          </form>
        </div>

        <!--MYORDER-->
        <div class="myprofile-order pl-25" id="MyOrder">

          <!--- 28 sep VIP -->
          <div class="back-btn hidelg mb-3 profile-heading">
            <a (click)="goBacktoMyAccount()" class="mr-15">
              <img src="assets/images/icons/back-black-arrow-light.png" alt="">
            </a>
            My Order
          </div>
          <!--- 28 sep VIP -->
          <div class="myprofile-order-wrp" *ngIf="orders">
            <ul class="uk-subnav uk-subnav-pill myprofile-order-tab" uk-switcher>
              <li><a href="#">Paid</a></li>
              <li><a href="#">Cancelled</a></li>
            </ul>
            <ul class="uk-switcher">
              <li>
                <ng-container *ngIf="orders.PROCESSING && orders.PROCESSING.length > 0">
                  <div class="myorder-card uk-flex uk-flex-bottom" *ngFor="let order of orders.PROCESSING">
                    <div class="image w-30 cursor-pointer" (click)="showOrderSummary(order)">
                      <img src="{{order.product.featured_image}}" alt="">
                    </div>
                    <div class="details w-70">
                      <div class="location-info uk-flex uk-flex-between mb-1">
                        <p>
                          <!--<img src="assets/images/icons/location-black.png" alt="">-->
                          <i class="fa fa-map-marker"></i>&nbsp; {{order.product.city}}</p>

                        <a (click)="showCancellationForm(order)" *ngIf="!order.order.cancel_status">
                          Request Cancellation
                        </a>

                        <ng-container *ngIf="order.deals_voucher[0]?.voucher_expired !== true">
                          <p *ngIf="order.order.cancel_status === 'AWAITING'">Cancellation Requested</p>
                          <p *ngIf="order.order.cancel_status === 'INITIATED'">Cancellation Requested</p>
                          <p *ngIf="order.order.cancel_status === 'INPROCESS'">Cancellation Requested</p>
                          <p *ngIf="order.order.cancel_status === 'COMPLETED'">Cancellation Completed</p>
                          <p *ngIf="order.order.cancel_status === 'REJECTED'">Cancellation Rejected</p>
                        </ng-container>

                        <ng-container *ngIf="order.deals_voucher[0]?.voucher_expired === true">
                          <p>Cancellation not allowed</p>
                        </ng-container>


                      </div>
                      <div class="order-name cursor-pointer" (click)="showOrderSummary(order)">
                        <h4>{{order.product.product_title}}</h4>
                        <p>{{order.product.category_name}}</p>
                      </div>
                      <div class="order-details uk-flex uk-flex-between"
                           *ngIf="order.product.product_type === 'EXPERIENCE' ">
                        <p class="w-70">{{order.orders_meta.event_date}}</p>

                        <h6 *ngIf="order.orders_meta.time_from !== '0:00'" class="w-30">{{order.orders_meta.time_from}}
                          - {{order.orders_meta.time_to}}</h6>
                        <h6 *ngIf="order.orders_meta.time_from === '0:00'" class="w-30">Any Time</h6>
                      </div>
                      <div class="order-details uk-flex uk-flex-between uk-flex-middle">
                        <h3 class="w-70">{{order.product.quantity}}x {{order.product.product_title}}
                          for {{order.orders_meta.ppl}} people </h3>
                        <h4 class="w-30"><i class="fa fa-rupee"></i> {{order.product.price | currency:'INR':'':'1.0-0'}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!orders.PROCESSING || orders.PROCESSING.length === 0">
                  <div class="myorder-card uk-flex uk-flex-bottom">
                    <p>No ongoing orders.</p>
                  </div>
                </ng-container>
              </li>

              <li>
                <ng-container *ngIf="orders.CANCELLED && orders.CANCELLED.length > 0">
                  <div class="myorder-card uk-flex uk-flex-bottom" *ngFor="let order of orders.CANCELLED">
                    <div class="image w-30">
                      <img src="{{order.product.featured_image}}" alt="">
                    </div>
                    <div class="details w-70">
                      <div class="location-info uk-flex uk-flex-between mb-1">
                        <p><!--<img src="assets/images/icons/location-black.png" alt="">-->
                          <i class="fa fa-map-marker"></i>&nbsp; {{order.product.city}}</p>
                      </div>
                      <div class="order-name">
                        <h4>{{order.product.product_title}}</h4>
                        <p>{{order.product.category_name}}</p>
                      </div>
                      <div class="order-details uk-flex uk-flex-between">
                        <p class="w-70">{{order.orders_meta.event_date}}</p>
                        <h6 class="w-30">{{order.orders_meta.time_from}} - {{order.orders_meta.time_to}}</h6>
                      </div>
                      <div class="order-details uk-flex uk-flex-between uk-flex-middle">
                        <h3 class="w-70">{{order.product.quantity}}x {{order.product.product_title}}
                          for {{order.orders_meta.ppl}} people</h3>
                        <h4 class="w-30"><i class="fa fa-rupee"></i> {{order.product.price | currency:'INR':'':'1.0-0'}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!orders.CANCELLED || orders.CANCELLED.length === 0">
                  <div class="myorder-card uk-flex uk-flex-bottom">
                    <p>No Cancelled products found.</p>
                  </div>
                </ng-container>
              </li>
            </ul>
          </div>

        </div>

        <!--BUCKETLIST-->
        <div class="mybucketlist pl-25" id="MyBucket">

          <!-- 28 sep vip-->
          <div class="back-btn hidelg mb-5 profile-heading">
            <a (click)="goBacktoMyAccount()" class="mr-15">
              <img src="assets/images/icons/back-black-arrow-light.png" alt="">
            </a>
            My Bucketlist
          </div>
          <!-- 28 sep vip-->

          <div class="mybucketlist-wrp mt-2">
            <ul class="uk-subnav uk-subnav-pill myprofile-order-tab" uk-switcher>
              <li><a href="#">Exclusive</a></li>
              <li><a href="#">Deals</a></li>
            </ul>
            <ul class="uk-switcher">
              <li>
                <ng-container *ngIf="bucketListProducts.EXPERIENCE && bucketListProducts.EXPERIENCE.length > 0">
                  <div class="uk-flex uk-flex-wrap experience-wrp-inner uk-margin-medium-top">
                    <div class="listing-card" *ngFor="let product of bucketListProducts.EXPERIENCE">
                      <div class="imageVideo">
                        <div class="image">
                          <div class="video">
                            <video class="vdo" inViewport [inViewportOptions]="{ threshold: [0] }"
                                   (inViewportAction)="onVideoIntersection($event)"
                                   poster="{{product.preview_video_image}}" src="{{product.video}}#t=0.1" loop="1"
                                   preload="none" muted="" (mouseover)="playVideo($event.target)"
                                   (mouseout)="pauseVideo($event.target)"></video>
                          </div>
                          <div class="voice">
                            <img src="assets/images/icons/sound.png" alt="" class="volumecontrol hidelg"
                                 (click)="videoVolumeControl($event.target)">
                          </div>
                        </div>
                      </div>
                      <div class="details" (click)="showProductDetail(product)">
                        <span>{{product.category.category_name}} </span>
                        <h4>{{product.title}} </h4>
                        <p>{{product.short_description}}</p>
                        <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]"
                           class="btn-yellow btn-yellow-bold center-block">Book
                          Now</a>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!bucketListProducts.EXPERIENCE || bucketListProducts.EXPERIENCE.length === 0">
                  <div class="myorder-card uk-flex uk-flex-bottom">
                    <p>No Exclusive products.</p>
                  </div>
                </ng-container>
              </li>

              <li>
                <ng-container *ngIf="bucketListProducts.STANDARD && bucketListProducts.STANDARD.length > 0">
                  <div class="uk-flex uk-flex-wrap experience-wrp-inner uk-margin-small-top ">
                    <app-standard-product-card class="standardCard w-46 mlf-2" [data]="product"
                                               *ngFor="let product of bucketListProducts.STANDARD">

                    </app-standard-product-card>
                  </div>
                </ng-container>
                <ng-container *ngIf="!bucketListProducts.STANDARD || bucketListProducts.STANDARD.length === 0">
                  <div class="myorder-card uk-flex uk-flex-bottom">
                    <p>No products found.</p>
                  </div>
                </ng-container>
              </li>
            </ul>
          </div>
          <!--mybucketlist-wrp-->
          <!--pagination-->

        </div>

        <!--MYCOUPONS-->
        <div class="mycoupons hidelg" id="MyCoupons">

          <div class="back-btn hidelg mb-3 profile-heading">
            <a (click)="goBacktoMyAccount()" class="mr-15">
              <img src="assets/images/icons/back-black-arrow-light.png" alt="">
            </a>
            My Coupons
          </div>

          <div class="mycoupons-wrp mt-2">
            <app-my-coupons [data]="coupon" *ngFor="let coupon of coupons"></app-my-coupons>
          </div>
          <!--mycoupons-wrp-->
        </div>

        <!--MyPollHistory-->
        <div class="mypollhistory hidelg" id="MyPollHistory">

          <div class="back-btn hidelg mb-3 profile-heading">
            <a (click)="goBacktoMyAccount()" class="mr-15">
              <img src="assets/images/icons/back-black-arrow-light.png" alt="">
            </a>
            My Poll History
          </div>

          <div class="mypollhistory mt-2">
            <app-poll-history [data]="pollData" *ngFor="let pollData of pollHistory"></app-poll-history>
          </div>
          <!--mycoupons-wrp-->
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Cancel Form -->
<div id="cancel-order" class="uk-flex-top" uk-modal>
  <div class="uk-modal-dialog  uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <div class="login-signup-wrp">
      <!-- LOGIN -->
      <div class="login-popup border-form-input">

        <form #cancelForm="ngForm" method="post" class="uk-form-stacked">
          <div class="form-group">
            <div class="uk-inline">
              <p *ngIf="selectedOrderForCancellation">You are about to cancel
                <b>{{selectedOrderForCancellation.product.product_title}}</b></p>

              <hr>
              <div class="mt-3 uk-text-left">
                <label class="uk-form-label">Select Reason</label>
                <div class="select-people-drop">
                  <select class="uk-select" name="user_cancel_comment"
                          [(ngModel)]="cancellationPayLoad.user_cancel_comment" #cancellationType="ngModel"
                          (change)="selectCancellationReason($event.target)">
                    <option value="">Select Reason</option>
                    <option value="Merchant Denial">Merchant Denial</option>
                    <option value="Bought by Mistake">Bought by Mistake</option>
                    <option value="Inaccurate website description">Inaccurate website description</option>
                    <option value="Decision Changed">Decision Changed</option>
                    <option value="Want to buy other product">Want to buy other product</option>
                    <option value="Outlet Closed/shut down"> Outlet Closed/shut down</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              <div class="uk-text-left mt-1">
                <label class="uk-form-label">Your Comments</label>
                <div class="uk-inline">
                  <textarea class="uk-input" name="order_feedback" id="order_feedback"
                            placeholder="Enter Cancellation Reason" required="required" maxlength="250"
                            [(ngModel)]="cancellationPayLoad.order_feedback" #cancellationReason="ngModel"></textarea>
                </div>
              </div>

            </div>

            <span class="error" *ngIf="cancellationErrorMessage">{{cancellationErrorMessage}}</span>

          </div>

          <div class="form-group mt-1">
            <button type="submit" class="btn-yellow btn-full" (click)="cancelOrder()">
              <i class="fa fa-spinner fa-spin" *ngIf="responseAwaited"></i> Submit
            </button>
            <p class="uk-text-success"> {{cancellationSuccessMessage}} </p>
          </div>
        </form>

      </div>

    </div>

  </div>
</div>

<!-- Order summary -->
<div id="order-summary" class="uk-flex-top uk-modal-container" uk-modal="bg-close: false">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical ">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <ng-container *ngIf="orderPaymentResponse">
      <div class="cashback mt-3 uk-flex uk-flex-middle"
           *ngIf="orderPaymentResponse && orderPaymentResponse.coupon?.length > 0">
                <span class="cashback-icon">
          <img src="assets/images/icons/cashback.png" alt="" border="0"/>
        </span>
        <ng-container *ngIf="orderPaymentResponse.coupon.length === 2">
          Congrats! You're now eligible for cashback of Rs 800/- we have sent you the details on your registered email
        </ng-container>

        <ng-container *ngIf="orderPaymentResponse.coupon.length === 3">
          Congrats! You're now eligible for cashback of Rs 1400/- we have sent you the details on your registered email
        </ng-container>
      </div>

      <div class="order-details-wrp uk-flex uk-flex-wrap mt-2">

        <div class="w-40">
          <div class="details-card">
            <h6 class="uk-flex uk-flex-middle">
              <img src="assets/images/icons/yellow-right.png" alt=""> Your Experience Details
            </h6>
            <div class="image mt-2">
              <img src="{{orderPaymentResponse.product.featured_image}}"
                   alt="{{orderPaymentResponse.product.product_title}}">
            </div>

            <div class="sharing-card-wrp">
              <h5 class="uk-flex uk-flex-middle"><!--<img src="assets/images/icons/location-black.png"
                                                      alt="">-->
                                                      <i class="fa fa-map-marker"></i> {{orderPaymentResponse.product.city}}</h5>
              <h4>{{orderPaymentResponse.product.product_title}}</h4>
              <div class="uk-flex uk-flex-middle">
                <span>{{orderPaymentResponse.product.category_name}}</span>
                <div class="position-relative">
                  <app-sharing [PageURL]=""
                               [PageFeaturedImage]="orderPaymentResponse.product.featured_image"></app-sharing>
                </div>
                <app-wishlist [productData]=product></app-wishlist>
              </div>
            </div>
            <!--sharing-card-wrp-->

            <div class="date-and-time-wrp uk-flex uk-flex-middle uk-flex-between"
                 *ngIf="orderPaymentResponse.product.product_type !== 'STANDARD'"
                 style="{{orderPaymentResponse.product.product_type !== 'STANDARD'?'visibility:hidden':''}}">
              <div class="dt-card">
                <h4>Date and Time</h4>
                <p>{{orderPaymentResponse.orders_meta.event_date}}</p>
                <span>{{orderPaymentResponse.orders_meta.time_from}}
                  - {{orderPaymentResponse.orders_meta.time_to}}</span>
              </div>
            </div>

          </div>
        </div>
        <!--w-35--->

        <div class="w-60">

          <div class="voucher-code text-center">
            <h4>Your Unique Voucher Code</h4>
            <div class="code"
                 *ngFor="let code of orderPaymentResponse.deals_voucher[0].voucherDetail">{{code.voucher_code}}</div>
            <p>Show this code to our partner(s) and redeem your experience seamlessly</p>
          </div>
          <!--voucher-code--->

          <div class="order-summery uk-flex">
            <div class="order-summery-card rightangle">
              <h5>Order Summary</h5>
              <div class="uk-flex order-price">
                <p class="w-50">{{orderPaymentResponse.product.quantity}}
                  x {{orderPaymentResponse.product.product_title}} for {{orderPaymentResponse.orders_meta.ppl}} people
                </p>
                <h4 class="w-50"><i
                  class="fa fa-rupee"></i>{{orderPaymentResponse.product.price | currency:'INR':'':'1.0-0'}}</h4>
              </div>
              <div class="order-table uk-flex" *ngIf="orderPaymentResponse.order.price_breakup?.coupon ">
                <div class="w-50">
                  <p>Coupon ({{orderPaymentResponse.order.price_breakup?.coupon}})</p>
                </div>
                <div class="w-50">
                  <h6><i class="fa fa-rupee"></i>
                    -{{orderPaymentResponse.order.price_breakup?.discount | currency:'INR':'':'1.0-0'}}</h6>
                </div>
              </div>
              <div class="order-table uk-flex" *ngIf="orderPaymentResponse.product.price">
                <div class="w-50">
                  <p>Convenience Fee</p>
                </div>
                <div class="w-50">
                  <h6><i
                    class="fa fa-rupee"></i> {{(orderPaymentResponse.product.price * orderPaymentResponse.product.convenience / 100) | currency:'INR':'':'1.0-0'}}
                  </h6>
                </div>
              </div>
              <div class="order-table uk-flex">
                <div class="w-50">
                  <p>Paid On</p>
                </div>
                <div class="w-50">
                  <h6>{{orderPaymentResponse.order.order_date}}</h6>
                </div>
              </div>
              <div class="order-table uk-flex">
                <div class="w-50">
                  <p>Payment Method</p>
                </div>
                <div class="w-50">
                  <h6>{{orderPaymentResponse.order.payment_method}}</h6>
                </div>
              </div>
            </div>
            <div class="order-details text-center">
              <h5>Order ID : {{orderPaymentResponse.order.order_id}}</h5>
              <p>Total (INR)</p>
              <h4><i
                class="fa fa-rupee"></i> {{(orderPaymentResponse.order.price_breakup?.final_price ? orderPaymentResponse.order.price_breakup?.final_price : orderPaymentResponse.product.price) | currency:'INR':'':'1.0-0'}}
              </h4>
            </div>
          </div>

        </div>
        <!--65--->

      </div>

      <div class="need-help uk-flex uk-flex-middle uk-flex-between mt-2">
        <div class="info">
          <h4>Need our Help?</h4>
          <p>Having troubles or questions about this experience? Reach out to us!</p>
        </div>
        <div class="number">
          <a href="tel:18002667666"> <img src="assets/images/icons/call-4.png" alt=""> 1800 266 7666</a>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<app-footer></app-footer>
